import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FileUploaderBrodcastService {

  public channel: BroadcastChannel;
  public constructor() {
    this.channel = new BroadcastChannel('upload_file');
  }

  public postMessage(instructions: any) {
    this.channel.postMessage(instructions);
  }

  public registerWorkerMessageListener(onProgress: any, onUploadStarted: any, onDeleteFile: any, onStopped: any, onCompleteUpload:any) {
    this.channel.onmessage = (event: any) => {
      const data = event.data;
      if (data.action == "progress") {
        onProgress(data);
      } else if (data.action == "upload-started") {
        onUploadStarted(data);
      } else if (data.action == "delete") {
        onDeleteFile(data);
      } else if (data.action == "stopped") {
        onStopped(data);
      } else if (data.action === "on-complete-upload") {
        onCompleteUpload(data);
      }
    }
  }
}
